
import { defineComponent } from "vue";
import { mdToHTML } from "@/core/markdown";

export default defineComponent({
  name: "MarkdownItem",
  props: {
    content: { type: String, required: true },
  },
  methods: {
    mdToHTML,
  },
});
